import React, { Component } from 'react';
import Button from '../button';

export default class FaltaDireccion extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loading_text: '',
         Message: '',
      };
   }
   componentDidMount() {
      const modal = document.getElementById('modal-falta-direccion');
      modal.style.display = 'none';
   }
   close() {
      const modal = document.getElementById('modal-falta-direccion');
      modal.style.display = 'none';
   }
   render() {
      return (
         <div className="modal-login justify-center" id="modal-falta-direccion">
            <div className="container">
               <div className="modal-content-alert">
                  <div className="column">
                     <div className="login-method row-responsive">
                        <div className="column">
                           <h2 className="login-title text-center">
                              Selecciona una sucursal de envío
                           </h2>
                           <div className="white-space-32"></div>
                           <div className="row-responsive justify-center">
                              <Button onClick={this.close.bind(this)}>
                                 Aceptar
                              </Button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Modals/faltadireccion.js